<div fxLayout="row">
    <div *ngFor="let stat of userStats" fxFlex="50">
        <lib-basic-stat [stat]="stat"></lib-basic-stat>
    </div>
</div>